// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"6ce89bf1","835":"22bfc7e4","957":"2e79710c"}[chunkId] + ".chunk.css";
};